import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-modal-confirm',
  template: `
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center">
      <div class="bg-white p-4 rounded max-w-lg w-full">
        <h3 class="font-semibold">{{ title }}</h3>
        <p class="mt-2">{{ message }}</p>
        <div class="mt-4 flex justify-end gap-2">
          <button (click)="cancel.emit()" class="px-3 py-1">Cancelar</button>
          <button (click)="confirm.emit()" class="px-3 py-1 bg-danger text-white">Excluir</button>
        </div>
      </div>
    </div>
  `
})
export class ModalConfirmComponent {
  @Input() title = 'Confirmar';
  @Input() message = 'Tem certeza?';
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
